<template>
  <div class="range-select">
    <el-select
      v-model="start"
      class="start-select"
      :disabled="disabled"
      :clearable="clearable"
      :filterable="filterable"
      :value-key="valueKey"
      :placeholder="startPlaceholder"
    >
      <el-option
        v-for="(option, index) in startOptionList"
        :key="index"
        :label="optionLabelKey ? option[optionLabelKey] : option.label"
        :value="optionValueKey ? option[optionValueKey] : option.value"
      />
    </el-select>
    <el-select
      v-model="end"
      class="end-select"
      :disabled="disabled"
      :clearable="clearable"
      :filterable="filterable"
      :value-key="valueKey"
      :placeholder="endPlaceholder"
    >
      <el-option
        v-for="(option, index) in endOptionList"
        :key="index"
        :label="optionLabelKey ? option[optionLabelKey] : option.label"
        :value="optionValueKey ? option[optionValueKey] : option.value"
      />
    </el-select>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionList: {
      type: [Object, Array],
      required: true
    },
    optionLabelKey: {

    },
    optionValueKey: {

    },
    startPlaceholder: {

    },
    endPlaceholder: {

    },
    valueKey: {

    },
    disabledStartOption: {

    },
    disabledEndOption: {

    }
  },
  data () {
    return {

    }
  },
  computed: {
    startOptionList () {
      if (this.disabledStartOption) {
        return _.filter(this.optionList, (option, index) => {
          const disabled = this.disabledStartOption(index, option)
          return !disabled
        })
      } else {
        return this.optionList
      }
    },
    endOptionList () {
      if (this.disabledEndOption) {
        return _.filter(this.optionList, (option, index) => {
          const disabled = this.disabledEndOption(this.start, index, option)
          return !disabled
        })
      } else {
        const startIndex = this.start ? _.findIndex(this.startOptionList, { [this.optionValueKey || 'value']: this.start }) : -1
        return _.filter(this.optionList, (option, index) => startIndex <= index)
      }
    },
    start: {
      get () {
        return this.value && this.value[0]
      },
      set (val) {
        if (this.end) {
          const foundEnd = _.findIndex(this.endOptionList, { [this.optionValueKey || 'value']: this.end }) > -1
          if (!foundEnd) {
            this.end = null
            return
          }
        }
        this.$emit('change', [val, this.end])
      }
    },
    end: {
      get () {
        return this.value && this.value[1]
      },
      set (val) {
        this.$emit('change', [this.start, val])
      }
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.range-select {
  .start-select {
    &.el-select {
      width: 50%;
    }

    &:hover {
      margin-right: -1px;
      position: relative;
      z-index: 1;

      + .end-select {
        margin-left: 0;
      }
    }

    ::v-deep {
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  .end-select {
    margin-left: -1px;

    &.el-select {
      width: 50%;
    }

    ::v-deep {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
